import { render, staticRenderFns } from "./radio-field.vue?vue&type=template&id=c9c65914&scoped=true"
import script from "./radio-field.vue?vue&type=script&lang=ts"
export * from "./radio-field.vue?vue&type=script&lang=ts"
import style0 from "./radio-field.vue?vue&type=style&index=0&id=c9c65914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c65914",
  null
  
)

export default component.exports